import type { ScoreValue } from '../../schema/brands.js';

/** Klemmt einen Roh-Score auf [0, 100] und brandet das Ergebnis. */
export function clampScore(raw: number): ScoreValue {
  const clamped = Math.max(0, Math.min(100, Math.round(raw)));
  return clamped as ScoreValue;
}
